import { graphql } from '@apollo/react-hoc';
import gql from 'graphql-tag';
import { withRouter } from 'react-router';
import SFTPSettingsPage from './sftp-settings';
import { SimpleLoadingComponent } from '../../utils/apollo';

export const query = gql`
  query NewSFTPSettingsComponent {
    viewer {
      id
      activeMatchExportConfiguration {
        id
        isNew
        sftpHost
        connectionTestSuccess
        lastModified
      }
      activeMatchExportTransferSummary {
        successfulJob
        createdAt
        transferFailureReason
        lastSuccessAt
      }
    }
  }
`;

const graphqlData = graphql(query, {
  options: ({ params }) => {
    const { id = '' } = params;
    return {
      skip: !id,
      variables: {
        id,
      },
      fetchPolicy: 'network-only',
    };
  },
});

export default withRouter(SimpleLoadingComponent(graphqlData)(SFTPSettingsPage));
